import { j as F } from "./jsx-runtime-3tyXYecC.mjs";
import { forwardRef as K, useRef as V, useImperativeHandle as G, useMemo as J } from "react";
import { I as Q } from "./input-wrapper-qaVcukod.mjs";
import { u as U } from "./use-readable-context-BO-ExsvT.mjs";
import { f as R } from "./index-LyFokDcn.mjs";
import { w as v } from "./sizes-DktS74Qp.mjs";
import { m as X, b as Y } from "./tss-DN0acMKN.mjs";
import { _ as Z } from "./composeRefs-YONvD-rx.mjs";
import { l as ee } from "./lodash-5ofSKtz3.mjs";
import { T as te } from "./TextareaAutosize-CWylSdQ8.mjs";
import { g as oe } from "./get-aria-describedby-G1wcWKF2.mjs";
import { g as re } from "./get-status-message-CGqgCpjJ.mjs";
const ie = 1.25, ae = {
  teenie: 28,
  small: 32,
  medium: 34,
  large: 36,
  biggie: 42
}, ne = {
  teenie: 0.875,
  small: 0.9375,
  medium: 0.625,
  large: 0.625,
  biggie: 1.315
}, se = X()((a, p) => {
  var f, c;
  const { borderRadiuses: g, mixins: t, spacing: u, transitions: n, palette: e, typography: o } = a, { disabled: r = !1, size: l = "medium", status: i, viewMode: m = !1, width: d } = p, b = (h) => {
    const s = { fontSize: o.medium.fontSize, lineHeight: o.medium.lineHeight };
    return {
      teenie: o.small,
      small: o.small,
      medium: o.medium,
      large: o.large,
      biggie: o.large
    }[h] ?? s;
  };
  return R.ifFeature(
    "encore",
    {
      textAreaRoot: {
        backgroundColor: r ? e.gray[50] : e.common.white,
        borderRadius: g[200],
        boxSizing: "border-box",
        color: r ? e.gray[600] : e.gray[800],
        fontFamily: o.fontFamily,
        padding: `9px ${u(2)} 9px ${u(1.5)}`,
        // 9px to match the spacing on the other inputs
        ...t.inputOutline(a, { disabled: r, status: i, viewMode: m }),
        transition: n.create(["border", "box-shadow"]),
        "&:hover": {
          ...t.inputOutline(a, { disabled: r, hover: !0, status: i, viewMode: m })
        },
        "&:focus, &:focus-within": {
          ...t.inputOutline(a, { disabled: r, focused: !0, status: i, viewMode: m })
        },
        position: "relative",
        resize: "both",
        "&::placeholder": {
          color: e.gray[600],
          opacity: 1
        },
        "&.Mui-disabled": {
          color: e.gray[600],
          WebkitTextFillColor: "unset",
          "&::placeholder": {
            color: e.gray[600],
            opacity: 1
          }
        }
      },
      denseAdornment: {},
      width: {
        width: !d || d === 100 ? "100%" : v[d]
      },
      input: {},
      label: {},
      size: {
        ...b(l)
      }
    },
    {
      textAreaRoot: {
        backgroundColor: e.common.white,
        borderRadius: 2,
        fontFamily: o.fontFamily,
        border: r ? t.border(1, e.grey[300]) : i ? t.border(1, t.fieldStatusColor(i, e)) : m ? t.border(1, e.grey[300]) : t.border(1, e.grey[400]),
        transitions: n.create(["border-color", "box-shadow"]),
        "&:hover": {
          border: !r && !i && m ? t.border(1, e.grey[400]) : void 0,
          boxShadow: r ? "none" : "0 1px 0 0 rgba(0, 0, 0, 0.05)"
        },
        "&:focus-within": {
          borderColor: t.fieldStatusColor(i, e, e.primary.lighter),
          boxShadow: `${Y(t.fieldStatusColor(i, e, e.primary.lighter), 0.25)} 0 0 0 2px`
        },
        "&>.MuiInputAdornment-positionEnd": {
          marginRight: -10
        },
        "&>.MuiInputAdornment-positionStart": {
          marginRight: -10
        },
        "&>.MuiInputAdornment-root": {
          backgroundColor: e.gray[100],
          height: ae[l] - 2,
          justifyContent: "center",
          maxHeight: "unset",
          padding: R.ifFeature("encore", u(1.5), u(0, ["large", "biggie"].includes(l) ? 1 : 0.75))
        },
        outline: "none"
      },
      denseAdornment: {
        "&.MuiInputBase-root>.MuiInputAdornment-root": {
          padding: 0
        }
      },
      width: {
        width: !d || d === 100 ? "100%" : v[d]
      },
      input: {
        boxSizing: "border-box",
        height: "unset",
        position: "relative"
      },
      label: {},
      size: {
        fontSize: (f = o[l]) == null ? void 0 : f.fontSize,
        lineHeight: (c = o[l]) == null ? void 0 : c.lineHeight,
        padding: u(ne[l], ie)
      }
    }
  );
}), le = K((a, p) => {
  let g = a;
  const { viewMode: t = !1 } = a, { isReadable: u } = U(), { classes: n, cx: e } = se(a);
  if (u || t) {
    const { placeholder: w, ..._ } = a;
    g = _;
  }
  const {
    afterLabel: o,
    apiRef: r,
    ariaDescribedby: l,
    autoFocus: i,
    className: m,
    containerRef: d,
    disabled: b = !1,
    errorMessage: f,
    id: c,
    InputLabelProps: h,
    InputProps: s,
    inputProps: z = {},
    label: C,
    labelPlacement: I,
    name: T,
    minRows: j = R.ifFeature("encore", 3),
    width: H,
    note: k,
    onBlur: P,
    onChange: B,
    onFocus: D,
    onKeyDown: E,
    notePlacement: O,
    placeholder: $,
    required: q = !1,
    status: x,
    value: L,
    warningMessage: N,
    ...M
  } = g, y = V(null);
  G(
    r,
    () => ({
      focus: () => {
        var w;
        (w = y.current) == null || w.focus();
      }
    }),
    [y]
  );
  const S = re(x, f, N), A = J(() => ee.uniqueId("fabric-text-area-status-message-"), []), W = [M["data-fabric-component"], "TextArea"].filter(Boolean).join(" ");
  return /* @__PURE__ */ F.jsx(
    Q,
    {
      afterLabel: o,
      classes: {
        label: n.label,
        width: n.width
      },
      className: m,
      "data-fabric-component": W,
      disabled: b,
      id: c,
      InputLabelProps: h,
      label: C,
      labelPlacement: I,
      note: k,
      notePlacement: O,
      ref: d,
      required: q,
      status: x,
      statusMessage: S,
      statusMessageId: A,
      width: H,
      children: /* @__PURE__ */ F.jsx(
        te,
        {
          ...s,
          ...M,
          ...z,
          "aria-describedby": oe(
            S ? A : "",
            l,
            s == null ? void 0 : s["aria-describedby"]
          ),
          "aria-invalid": x === "error" || (s == null ? void 0 : s["aria-invalid"]),
          autoFocus: i,
          className: e(n.textAreaRoot, n.size, n.width, n.denseAdornment),
          disabled: b,
          id: c,
          minRows: j,
          name: T,
          onBlur: P,
          onChange: B,
          onFocus: D,
          onKeyDown: E,
          placeholder: $,
          ref: Z(p, y),
          value: L
        }
      )
    }
  );
});
le.defaultProps = {
  disabled: !1,
  size: "medium",
  width: 100
};
export {
  le as T
};
//# sourceMappingURL=text-area-CajlHzg4.mjs.map
